<template>
  <b-dialog
    :visible="isVisible"
    :title="title"
    :cancelButtonText="buttonText.cancel"
    :buttonText="buttonText.confirm"
    @close="close" 
    @cancel="close"
    @submit="submit"
    class="live-report"
  >
    <template v-if="reportInfo?.type === 'room'">
      <form>
        <template v-if="!reportInfo.reason">
          <ul class="reason-list padding">
            <li v-for="(r, $index) in reasons" :key="r">
              <input type="radio" name="reason" :value="r" :id="`report-reason-${$index}`" @change="setReason"/>
              <label :for="`report-reason-${$index}`">{{r}}</label>
            </li>
          </ul>
        </template>
        <template v-else>
          <div>{{reportInfo?.reason}}</div>
          <label for="description">补充描述</label>
          <input type="textarea" id="description"/>
        </template>
      </form>
    </template>
    <template v-else-if="reportInfo?.type === 'comment'">
      <form>
        <ul class="reason-list">
          <li v-for="(r, $index) in reasons" :key="r">
            <input type="radio" name="reason" :value="r" :id="`report-reason-${$index}`" @change="setReason"/>
            <label :for="`report-reason-${$index}`">{{r}}</label>
          </li>
        </ul>
      </form>
    </template>
  </b-dialog>
</template>

<script lang="ts" setup>
import { BDialog } from '@bilibili-intl/components';
import emitter, { EB_EVENT_NAME, IOpenReportModalData } from '@/utils/eventbus';
import { computed, ComputedRef, onMounted, reactive, ref, Ref } from 'vue';
import toast from '../toast';
import { IToastOptions } from '../toast/toast-types';
import i18n from '@/locales/index';

const commentToastProps: IToastOptions = {
  duration: 3000,
  appendTo: '.live-comment-container',
};

const roomToastProps: IToastOptions = {
  duration: 3000,
  appendTo: 'body'
};

// const roomService = new RoomService();
const $t = i18n().global.t;

const reportInfo: Ref<IOpenReportModalData | null> = ref(null);

const title: ComputedRef<string> = computed(() => {
  return reportInfo.value?.type === 'comment' ? 'Report Danmaku' : 'Report Live Room';
});

const reasons = reactive([
  '违法犯罪内容',
  '色情裸露内容',
  '辱骂骚扰',
  '虚假信息传播',
  '种族、性别、宗教等不当言论',
  '宣扬暴力、唆使伤害和死亡',
  '诈骗、垃圾广告',
  '其他',
]);

const isVisible:Ref<boolean> = ref(false);

const onModalOpen = (params: IOpenReportModalData) => {
  isVisible.value = true;
  reportInfo.value = params;
};

const close = () => {
  isVisible.value = false;
  reportInfo.value = null;
};

onMounted(() => {
  emitter.on(EB_EVENT_NAME.OPEN_REPORT_MODAL, onModalOpen);
});

// 确认/取消按钮展现
const buttonText = computed(() => {
  if (reportInfo.value?.type === 'room' && !reportInfo.value?.reason) {
    return {};
  }
  return {
    confirm: $t('common.confirm'),
    cancel: $t('common.cancel'),
  };
});

const setReason = (event: PointerEvent) => {
  reportInfo.value.reason = event.target?.value;

};

const submit = () => {
  if (reportInfo.value.reason) {
    return;
  }

  if (reportInfo.value?.type === 'room') {
    toast({
      ...roomToastProps,
      message: '请填写原因',
    });
  }
  // toast({
  // ...commentToastProps,
  // message: '请填写原因',
  // });
  
};

</script>


<style lang="less" scoped>
.reason-list {
  padding-top: 18px;

  & > li + li {
    margin-top: 10px;
  }

  input[type="radio"] {
    appearance: auto;
    margin-right: 10px;
  }

  &.padding {
    padding-bottom: 40px;
  }
}

input[type="textarea"] {
  border: 1px solid #ccc;
  border-radius: 4px;
  display: block;
  width: 100%;
  height: 150px;
  margin-top: 10px;
}
  
</style>